/****************************************************
 * Module Name:  virtualTeamRole.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Box, Typography } from "@mui/material";
import Constants from "../../utility/constants";
import DualListBox from "react-dual-listbox";
import "react-dual-listbox/lib/react-dual-listbox.css";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import BlockIcon from "@mui/icons-material/Block";
import AddTaskIcon from "@mui/icons-material/AddTask";
import VirtualTeamProxy from "../../utility/proxy/manager/permissionProxy/virtualTeamProxy";
import RoleProxy from "../../utility/proxy/manager/permissionProxy/roleProxy";
import UserRoleProxy from "../../utility/proxy/manager/permissionProxy/userRoleProxy";
import Utility from "../../utility/utility";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import { LoadingButton } from "@mui/lab";

const fullOptionToValue = (selectedData) => {
  let arr = [];
  selectedData.map((option) => {
    arr.push({ roleid: option.sendValue, type: option.type });
    return arr;
  });
  return arr;
};

const VirtualTeamRole = () => {
  const [virtualTeam, setVirtualTeam] = useState("");
  const [virtualTeamOptions, setVirtualTeamOptions] = useState([]);
  const [selected, setSelected] = useState([]);
  const [roleOption, setRoleOption] = useState([]);
  const [successSnackbar, setSuccessSnackbar] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [errorSnackbar, setErrorSnackbar] = useState(false);
  const [grantLoader, setGrantLoader] = useState(false);
  const [revokeLoader, setRevokeLoader] = useState(false);
  // eslint-disable-next-line
  const [local_Permission, setLocal_Permission] = useState(
    Constants.USER_PERMISSION.filter(
      (iPermission) =>
        iPermission.permissionid ===
        Constants.PERMISSIONS.PERMISSION_USERROLE_VIRTUALTEAM
    )
  );

  useEffect(() => {
    getAllVirtualTeam();
    getAllVirtualTeamRole();
  }, []);

  const onChange = (value) => {
    setSelected(value);
  };

  const getAllVirtualTeam = () => {
    VirtualTeamProxy.GetAllVirtualTeamMini((response) => {
      if (response) {
        setAllVirtualTeamData(response)
      } else {
        setErrorSnackbar(true)
      }
    }
    );
  };

  const setAllVirtualTeamData = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = { value: data.id, label: data.name };
      optionsArray.push(option);
      return true;
    });
    setVirtualTeamOptions(optionsArray);
    setVirtualTeam(
      virtualTeam === "" && optionsArray.length > 0
        ? optionsArray[0]
        : virtualTeam
    );
  };

  const getAllVirtualTeamRole = () => {
    RoleProxy.GetAllRoleDetail((response) => {
      if (response) {
        setAllVirtualTeamRoleData(response)
      } else {
        setErrorSnackbar(true)
      }
    }
    );
  };

  const setAllVirtualTeamRoleData = (response) => {
    let optionsArray = [];
    let uniqueId = 0;
    response.map((option) => {
      Constants.PERMISSION_TYPE.map((permission) => {
        uniqueId++;
        let option1 = {
          value: uniqueId,
          label: option.name + " - " + permission,
          type: permission,
          sendValue: option.id,
        };
        uniqueId++;
        optionsArray.push(option1);
        return true;
      });
      return true;
    });
    setRoleOption(optionsArray);
  };

  const handleGrantVirtualTeamRole = () => {
    let data = fullOptionToValue(selected);
    setGrantLoader(true);
    UserRoleProxy.AddVirtualTeamRole(virtualTeam.value, data, (response) => {
      if (response) {
        setSnackMessage(response);
        setSuccessSnackbar(true);
        setGrantLoader(false);
      } else {
        setGrantLoader(false);
        setErrorSnackbar(true);
      }
    });
  };

  const handleRevokeVirtualTeamRole = () => {
    let data = fullOptionToValue(selected);
    setRevokeLoader(true);
    UserRoleProxy.DeleteVirtualTeamRole(virtualTeam.value, data, (response) => {
      if (response) {
        setSnackMessage(response);
        setSuccessSnackbar(true);
        setRevokeLoader(false);
      } else {
        setRevokeLoader(false);
        setErrorSnackbar(true);
      }
    });
  };

  return (
    <Box>
      <TabMenuSnackbar
        show={errorSnackbar}
        message={Constants.APiFailErrorMessage}
        variant={"error"}
        autoHide={Constants.SnackBarCloseTimer}
        title={"Error"}
        handleClose={() => setErrorSnackbar(false)}
      />
      {successSnackbar ? (
        <TabMenuSnackbar
          show={true}
          message={<Box>{snackMessage.errorMessage}</Box>}
          variant={snackMessage.status.toLowerCase()}
          autoHide={snackMessage.status === "Success" ? true : false}
          handleClose={() => setSuccessSnackbar(false)}
          title={snackMessage.status}
        />
      ) : null}
      <Box
        sx={{
          display: "flex",
          minWidth: "350px",
          maxWidth: "auto",
          gap: "20px",
          mb: 1,
          px: 1
        }}
      >
        <Box sx={{ alignSelf: "center", mt: 2 }}>
          <Typography>Virtual Team</Typography>
        </Box>
        <Box
          sx={{
            alignSelf: "center",
            minWidth: "350px",
            maxWidth: "auto",
            mt: 2,
          }}
        >
          <Select menuPlacement="auto"
            blurInputOnSelect={false}
            className="basic-single"
            classNamePrefix="select"
            value={virtualTeamOptions.find(
              (ivirtualTeam) => ivirtualTeam.value === virtualTeam.value
            )}
            isSearchable={true}
            name="VirtualTeam"
            menuPortalTarget={document.body}
            styles={Constants.Styles}
            options={virtualTeamOptions}
            onChange={(selectedOption) => setVirtualTeam(selectedOption)}
          />
        </Box>
      </Box>
      <Box
        sx={{

          "& .rdl-controls": {
            minHeight: "550px",
            maxHeight: "700px",
          },
          backgroundColor: '#fff',
          color: '#000',
          height: '55vh',
          padding: 1
        }}
      >
        <DualListBox
          canFilter
          filterPlaceholder={"Search Roles"}
          // showNoOptionsText
          showHeaderLabels
          simpleValue={false}
          options={roleOption}
          selected={selected}
          onChange={onChange}
          icons={{
            moveLeft: <KeyboardArrowLeftIcon />,
            moveAllLeft: <KeyboardDoubleArrowLeftIcon />,
            moveRight: <KeyboardArrowRightIcon />,
            moveAllRight: <KeyboardDoubleArrowRightIcon />,
            // moveDown: <span className="fa fa-chevron-down" />,
            // moveUp: <span className="fa fa-chevron-up" />,
            // moveTop: <span className="fa fa-double-angle-up" />,
            // moveBottom: <span className="fa fa-double-angle-down" />,
          }}
        />
      </Box>
      <Box
        sx={{
          backgroundColor: '#fff',
          color: '#000',
          paddingBottom: 5,
          paddingRight: 5
        }}
        height={'15vh'}
        display="flex"
        alignItems="end"
        justifyContent="end"
        gap={"15px"}
      >
        {Utility.isUpdateAllowed(local_Permission) ||
          Utility.isAddAllowed(local_Permission) ? (
          <LoadingButton
            variant="contained"
            startIcon={<AddTaskIcon />}
            loading={grantLoader}
            loadingPosition="start"
            onClick={handleGrantVirtualTeamRole}
            disabled={virtualTeamOptions.length === 0 || selected.length === 0 || revokeLoader}
          >
            Grant
          </LoadingButton>
        ) : null}

        {Utility.isUpdateAllowed(local_Permission) ||
          Utility.isDeleteAllowed(local_Permission) ? (
          <LoadingButton
            sx={{ bgcolor: "#1a237e" }}
            variant="contained"
            loading={revokeLoader}
            loadingPosition="start"
            component="label"
            startIcon={<BlockIcon />}
            onClick={handleRevokeVirtualTeamRole}
            disabled={virtualTeamOptions.length === 0 || selected.length === 0 || grantLoader}
          >
            Revoke
          </LoadingButton>
        ) : null}
      </Box>
    </Box>
  );
};

export default VirtualTeamRole;
